export default "__VITE_ASSET__HA8yBTSo__"